import { createSlice, current } from "@reduxjs/toolkit";
import moment from "moment";
import { defaultEventsLoad, searchEventAssetId, searchEventsMulti, getEventAddress } from "./eventsApi";

export const eventsSlice = createSlice({
    name: 'events',
    initialState: {
        viewType: 'default',
        loading: false,
        loadComplete: false,
        eventDetailView: null,
        selectedAssetId: null,
        oneAssetEventList: [],
        eventList: [],
        searchEventList: [],
        eventContent: {},
        eventTicker: false,
        visibleEvents: [],
        eventPageIndex: null,
        eventPageCount: null,
        eventsPerPage: 25,

    },
    reducers: {
        setEventDetailView: (state, { payload }) => {
            //console.log("Event click", payload);
            state.eventDetailView = payload;
            return state;
        },
        removeEventDetailView: (state) => {
            state.eventDetailView = null;
            return state;
        },
        socketNewEvent: (state, { payload }) => {
            if (payload.length > 0) {
                //console.log("Sock payload", payload);
                payload.forEach(pl => {
                    const eventData = {
                        ...pl,
                        event_time: moment(pl.event_time).add(330, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
                    }
                    state.eventList.unshift(pl.event_id);
                    state.eventContent[`${pl.event_id}`] = eventData;
                    if (state.eventPageIndex === 1 && state.viewType === 'default') {
                        state.visibleEvents.unshift(pl.event_id);
                        state.visibleEvents.pop();
                    }
                })
            }
            //console.log("sock events", payload.length);
            return state;
        },
        deleteTroubleEvent: (state, { payload }) => {
            //console.log("Trouble Event", payload);
            if (state.eventDetailView === payload) {
                state.eventDetailView = null;
            }
            state.eventContent[`${payload}`] = {};
            const listIndex = state.eventList.indexOf(payload);
            const searchIndex = state.searchEventList.indexOf(payload);
            const oneAssetIndex = state.oneAssetEventList.indexOf(payload);
            const visibleIndex = state.visibleEvents.indexOf(payload);

            if (listIndex !== -1) {
                state.eventList.splice(listIndex, 1);
            }
            if (searchIndex !== -1) {
                state.searchEventList.splice(listIndex, 1);
            }
            if (oneAssetIndex !== -1) {
                state.oneAssetEventList.splice(listIndex, 1);
            }
            if (visibleIndex !== -1) {
                state.visibleEvents.splice(listIndex, 1);
            }
            //console.log("Trouble Event Removed");
            return state;
        },
        setSelectedAssetId: (state, { payload }) => {
            state.selectedAssetId = payload;
            const list = filterForAssetid(
                state.viewType,
                state.eventList, state.searchEventList, state.oneAssetEventList,
                state.eventContent, state.selectedAssetId
            );
            state.eventPageCount = Math.ceil(list.length / state.eventsPerPage);
            state.eventPageIndex = 1;
            const startIndex = 0;
            const endIndex = startIndex + state.eventsPerPage;
            state.visibleEvents = list.slice(startIndex, endIndex + 1);
            return state;
        },
        removeSelectedAssetId: (state) => {
            state.selectedAssetId = null;
            const list = getAppropriateList(state.viewType, state.eventList, state.searchEventList, state.oneAssetEventList);
            //console.log("remove asset", state.viewType, list.length);
            state.eventPageIndex = 1;
            const startIndex = 0;
            const endIndex = startIndex + state.eventsPerPage;
            state.visibleEvents = list.slice(startIndex, endIndex + 1);
            return state;
        },
        setViewType: (state, { payload }) => {
            state.viewType = payload;
            return state;
        },
        toggleEventTicker: (state) => {
            state.eventTicker = !state.eventTicker;
            return state;
        },
        setEventPageIndex: (state, { payload }) => {
            state.eventPageIndex = payload;
            const list = getAppropriateList(state.viewType, state.eventList, state.searchEventList, state.oneAssetEventList);
            const startIndex = (state.eventPageIndex - 1) * state.eventsPerPage + 1;
            const endIndex = startIndex + state.eventsPerPage;
            state.visibleEvents = list.slice(startIndex, endIndex + 1);
            return state;
        },
        incrementEventPageIndex: (state) => {
            if (state.eventPageIndex < state.eventPageCount) {
                let list;
                if (!state.selectedAssetId) {
                    list = getAppropriateList(state.viewType, state.eventList, state.searchEventList, state.oneAssetEventList);
                } else {
                    list = filterForAssetid(
                        state.viewType,
                        state.eventList, state.searchEventList, state.oneAssetEventList,
                        state.eventContent, state.selectedAssetId
                    );
                }
                //console.log("Incr", state.viewType, list.length, state.eventPageIndex);

                /*const startIndex = state.eventPageIndex * state.eventsPerPage;
                const endIndex = startIndex + state.eventsPerPage - 1;
                state.eventPageIndex++;
                */
                state.eventPageIndex++;
                const startIndex = state.eventPageIndex === 1 ? 0 : (state.eventPageIndex - 1) * state.eventsPerPage;
                const endIndex = startIndex + state.eventsPerPage - 1;

                //console.log("startIndex", startIndex, endIndex);
                state.visibleEvents = list.slice(startIndex, endIndex + 1);
            }

            return state;
        },
        decrementEventPageIndex: (state) => {
            if (state.eventPageIndex > 1) {
                let list;
                if (!state.selectedAssetId) {
                    list = getAppropriateList(state.viewType, state.eventList, state.searchEventList, state.oneAssetEventList);
                } else {
                    list = filterForAssetid(
                        state.viewType,
                        state.eventList, state.searchEventList, state.oneAssetEventList,
                        state.eventContent, state.selectedAssetId
                    );
                }
                //console.log("Decr", state.viewType, list.length, state.eventPageIndex);
                state.eventPageIndex--;
                const startIndex = state.eventPageIndex === 1 ? 0 : (state.eventPageIndex - 1) * state.eventsPerPage;
                const endIndex = startIndex + state.eventsPerPage - 1;
                //console.log("startIndex", startIndex, endIndex);
                state.visibleEvents = list.slice(startIndex, endIndex + 1);
            }
            return state;
        },
        setEventsPerPage: (state, { payload }) => {
            state.eventsPerPage = payload;
            let list;
            if (!state.selectedAssetId) {
                list = getAppropriateList(state.viewType, state.eventList, state.searchEventList, state.oneAssetEventList);
            } else {
                list = filterForAssetid(
                    state.viewType,
                    state.eventList, state.searchEventList, state.oneAssetEventList,
                    state.eventContent, state.selectedAssetId
                );
            }
            const startIndex = 0;
            const endIndex = startIndex + state.eventsPerPage - 1;
            state.eventPageCount = Math.ceil(list.length / payload);
            state.visibleEvents = list.slice(startIndex, endIndex + 1);
            return state;
        },

    },
    extraReducers: {
        [searchEventAssetId.pending]: (state) => {
            state.loading = true;
            state.loadComplete = false;
            return state;
        },
        [searchEventsMulti.pending]: (state) => {
            state.loading = true;
            state.loadComplete = false;
            return state;
        },
        [defaultEventsLoad.pending]: (state) => {
            state.loading = true;
            state.loadComplete = false;
            return state;
        },

        [searchEventAssetId.fulfilled]: (state, { payload }) => {
            const { list, content, eventPageCount, visibleEvents } = eventProcessor(
                payload.events,
                [],
                current(state.eventContent),
                state.eventsPerPage,
            );
            state.viewType = 'oneAsset';
            state.oneAssetEventList = list;
            state.eventContent = content;
            state.eventPageIndex = 1;
            state.eventPageCount = eventPageCount;
            state.visibleEvents = visibleEvents;
            state.loading = false;
            state.loadComplete = true;
            //console.log("assetid event search", list);
            return state;
        },

        [searchEventsMulti.fulfilled]: (state, { payload }) => {
            const { list, content, eventPageCount, visibleEvents } = eventProcessor(
                payload.events,
                [],
                current(state.eventContent),
                state.eventsPerPage
            );
            state.viewType = 'search';
            state.searchEventList = list;
            state.eventContent = content;
            state.eventPageIndex = 1;
            state.eventPageCount = eventPageCount;
            state.visibleEvents = visibleEvents;
            state.loading = false;
            state.loadComplete = true;
            //console.log("Multi event search", list);
            return state;
        },

        [defaultEventsLoad.fulfilled]: (state, { payload }) => {
            const { list, content, eventPageCount, visibleEvents } = eventProcessor(
                payload.events,
                current(state.eventList),
                current(state.eventContent),
                state.eventsPerPage,
                state.selectedAssetId,
            );
            if (list.length < 30) {
                state.eventTicker = true;
            }
            //console.log("Curr assetid", state.selectedAssetId);
            state.viewType = 'default';
            state.eventList = list;
            state.eventContent = content;
            state.eventPageIndex = 1;
            state.eventPageCount = eventPageCount;
            state.visibleEvents = visibleEvents;
            state.loading = false;
            state.loadComplete = true;
            //console.log("Default Event Load", list);
            return state;
        },
        [getEventAddress.fulfilled]: (state, { payload }) => {
            state.eventContent[`${payload.eventId}`].address = payload.address;
            state.eventContent[`${payload.eventId}`].regn = payload.regn;
            return state;
        }
    },
});
export const {
    socketNewEvent, setViewType,
    setEventDetailView, removeEventDetailView,
    setSelectedAssetId, removeSelectedAssetId, toggleEventTicker,
    incrementEventPageIndex, decrementEventPageIndex,
    setEventsPerPage, deleteTroubleEvent,
} = eventsSlice.actions;
export { defaultEventsLoad, searchEventAssetId, searchEventsMulti, getEventAddress };

export const eventViewTypeSelector = state => state.events.viewType;
export const eventListSelector = state => state.events.eventList;
export const searchEventListSelector = state => state.events.searchEventList;
export const oneAssetEventListSelector = state => state.events.oneAssetEventList;
export const eventContentSelector = state => state.events.eventContent;
export const eventDetailViewSelector = state => state.events.eventDetailView;
export const selectedAssetIdEventsSelector = state => state.events.selectedAssetId;
export const visibleEventsSelector = state => state.events.visibleEvents;
export const eventPageIndexSelector = state => state.events.eventPageIndex;
export const eventPageCountSelector = state => state.events.eventPageCount;
export const eventsPerPageSelector = state => state.events.eventsPerPage;



function eventProcessor(apiData, currlist, currcontent, eventsPerPage, assetId = null) {
    let list = [...currlist];
    let content = { ...currcontent };

    apiData.forEach(event => {
        if (list.indexOf(event.event_id) === -1) {
            list.push(event.event_id);
        }
            if (event.event_desc.toUpperCase().search("SPEED") !== -1) {
                event.event_desc = `${event.event_desc} (${event.speed} Km/h)`;
            }
            content[`${event.event_id}`] = event;
    });
    list = sortEventList(list, content);

    //to handle situation when a vehicle is selected and last 24 hour events is demanded for that vehicle
    let templist = list;
    if (assetId) {
        templist = list.filter(a => content[`${a}`].assetID === assetId);
    }

    const eventPageCount = Math.ceil(templist.length / eventsPerPage);
    const visibleEvents = templist.slice(0, eventsPerPage + 1);


    //console.log("Reducer how many event", list.length, "page cnt", eventPageCount, "visivlke", visibleEvents.length);
    return { list, content, eventPageCount, visibleEvents };
}

function sortEventList(list, content) {
    list.sort(function (a, b) {
        const keyA = moment(content[`${a}`].event_time).unix();
        const keyB = moment(content[`${b}`].event_time).unix();

        return keyB - keyA;
    });
    return list;
}

function getAppropriateList(viewType, eventlist, searchlist, oneassetlist) {
    //console.log("view Type", viewType, eventlist.length, searchlist.length, oneassetlist.length);
    switch (viewType) {
        case 'default':
            return eventlist;
        case 'search':
            return searchlist;
        case 'oneAsset':
            return oneassetlist;
        default:
            return eventlist;
    };
}

function filterForAssetid(viewType, eventlist, searchlist, oneassetlist, eventcontent, assetId) {
    let sourcelist = [];
    switch (viewType) {
        case 'default':
            sourcelist = eventlist;
            break;
        case 'search':
            sourcelist = searchlist;
            break;
        case 'oneAsset':
            sourcelist = oneassetlist;
            break;
        default:
            sourcelist = eventlist;
            break;
    };
    const returnlist = sourcelist.filter(a => eventcontent[`${a}`].assetID === assetId);
    return returnlist;
}